import { render, staticRenderFns } from "./availability-toggle.vue?vue&type=template&id=98983380&scoped=true&"
import script from "./availability-toggle.vue?vue&type=script&lang=js&"
export * from "./availability-toggle.vue?vue&type=script&lang=js&"
import style0 from "./availability-toggle.vue?vue&type=style&index=0&id=98983380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98983380",
  null
  
)

export default component.exports